import { render, staticRenderFns } from "./BillStatis.vue?vue&type=template&id=648ea20e&scoped=true&"
import script from "./BillStatis.vue?vue&type=script&lang=ts&"
export * from "./BillStatis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648ea20e",
  null
  
)

export default component.exports